import { Alert, Badge } from "reactstrap";
import DateTimeText from "../../../../../components/DateTimeText";

function renderOptionalText(value: any)
{
    return value ? value : <span className="text-muted">—</span>;
}

function getBadgeColor(variant: string | null | undefined)
{
    switch (variant)
    {
        case 'success':
        case 'danger':
        case 'warning':
        case 'info':
        case 'primary':
        case 'secondary':
            return variant;
        default:
            return 'secondary';
    }
}

export function ProductDiagnosticsTable({ diagnostics }: { diagnostics: any[] })
{
    if (!diagnostics || diagnostics.length === 0)
    {
        return <Alert color="info">Brak interpretacji stanu dla podanych produktów.</Alert>;
    }

    return (
        <div className="table-responsive mt-3">
            <table className="table table-sm table-bordered mb-0">
                <thead>
                    <tr>
                        <th>Produkt</th>
                        <th>Profil</th>
                        <th>Stan</th>
                        <th>Co to oznacza</th>
                        <th>Rekord eksportu</th>
                    </tr>
                </thead>
                <tbody>
                    {diagnostics.map((item, index) => (
                        <tr key={`${item.productId}-${item.profileId}-${index}`}>
                            <td>{item.productId}</td>
                            <td>
                                <div>{item.profileName || <span className="text-muted">—</span>}</div>
                                {item.profileId && <code>{item.profileId}</code>}
                            </td>
                            <td>
                                <Badge color={getBadgeColor(item.displayVariant)}>
                                    {item.displayStatus || 'Nieznany stan'}
                                </Badge>
                                {item.isExcludedByGoogleMerchantCategory && (
                                    <div className="small text-muted mt-1">
                                        Wykluczona kategoria: {item.excludedGoogleMerchantCategoryId || '—'}
                                    </div>
                                )}
                            </td>
                            <td>
                                <div>{item.recommendedAction || item.eligibilityReason || item.lastMessage || <span className="text-muted">—</span>}</div>
                                {item.lastError && <div className="text-danger mt-1">{item.lastError}</div>}
                            </td>
                            <td>
                                {item.hasExportState ? (
                                    <>
                                        <div>
                                            <span className="text-muted">Status:</span> {item.status || '—'}
                                        </div>
                                        <div>
                                            <span className="text-muted">Operacja:</span> {item.desiredOperation || '—'}
                                        </div>
                                    </>
                                ) : (
                                    <span className="text-muted">Brak wpisu</span>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export function ExportStatesTable({ states }: { states: any[] })
{
    if (!states || states.length === 0)
    {
        return <Alert color="info">Brak technicznych rekordów w tabeli eksportu dla podanych produktów i profili.</Alert>;
    }

    return (
        <div className="table-responsive mt-3">
            <table className="table table-sm table-bordered mb-0">
                <thead>
                    <tr>
                        <th>Produkt</th>
                        <th>Profil</th>
                        <th>Status</th>
                        <th>Operacja</th>
                        <th>Current hash</th>
                        <th>Exported hash</th>
                        <th>Prepared</th>
                        <th>Exported</th>
                        <th>Komunikat</th>
                        <th>Błąd</th>
                    </tr>
                </thead>
                <tbody>
                    {states.map((state, index) => (
                        <tr key={`${state.productId}-${state.profileId}-${index}`}>
                            <td>{state.productId}</td>
                            <td><code>{state.profileId}</code></td>
                            <td>{state.status}</td>
                            <td>{state.desiredOperation}</td>
                            <td>{state.currentPayloadHash ? <code>{state.currentPayloadHash}</code> : <span className="text-muted">—</span>}</td>
                            <td>{state.exportedPayloadHash ? <code>{state.exportedPayloadHash}</code> : <span className="text-muted">—</span>}</td>
                            <td><DateTimeText value={state.preparedAt} /></td>
                            <td><DateTimeText value={state.exportedAt} /></td>
                            <td>{renderOptionalText(state.lastMessage)}</td>
                            <td>{state.lastError ? <span className="text-danger">{state.lastError}</span> : <span className="text-muted">—</span>}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
